export class NodeError extends Error {
  data: any;

  constructor(message: string, data = {}) {
    super(message);

    this.name = 'NodeError';
    this.data = {
      message,
      ...data,
    };
  }
}
